export const AppetiteStatus = {
  Active: 'active',
  Archived: 'archived',
} as const;

export type AppetiteStatus =
  (typeof AppetiteStatus)[keyof typeof AppetiteStatus];
